// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAY3qhKYiWFBnc1hM0m3IcxzPoFvrnXwCA",
    authDomain: "pipelapp-14f3c.firebaseapp.com",
    projectId: "pipelapp-14f3c",
    storageBucket: "pipelapp-14f3c.appspot.com",
    messagingSenderId: "151913083072",
    appId: "1:151913083072:web:11d7358d0d3aeb88063d25",
    measurementId: "G-2J0LWQPFKM"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
